import { inject, Injectable, signal } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { updatePreset } from "@primeng/themes";
import Aura from "@primeng/themes/aura";

import { AVAILABLE_THEMES } from "./theme.const";
import { AppTheme } from "./theme.model";

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly document = inject(DOCUMENT);

  private currentTheme = signal<AppTheme>(null);

  loadTheme(): void {
    const currentHost = this.document.location.hostname;
    let currentTheme = AVAILABLE_THEMES.find((theme: AppTheme) => theme.hosts.includes(currentHost));
    if (!currentTheme) {
      console.error(`Loading theme error: Unable to find style for host ${currentHost}`);
      console.warn(`Loading default theme`);
      currentTheme = AVAILABLE_THEMES.find((theme: AppTheme) => theme.name === 'default');
    }
    
    this.applyTheme(currentTheme);
  }

  applyTheme(theme: AppTheme): void {
    this.currentTheme.set(theme);
    this.applyThemePreset(theme);
    //dispatch custom event, to notify the theme has been changed (not mandatory but can be useful)
    this.document.dispatchEvent(new CustomEvent('theme-changed', { 
      detail: { 'current-theme': theme.name } 
    }));
  }

  getCurrentTheme(): AppTheme {
    return this.currentTheme();
  }

  //apply primeNG theme preset
  private applyThemePreset(theme: AppTheme): void {
    if (theme.preset) {
      console.log(`Applying theme : ${theme.name}`);
      updatePreset(Aura, theme.preset);
      console.log('Theme preset applied successfully !');
    } else {
      console.warn(`Theme: ${theme.name} not found. Using default theme instead.`);
    }
  }
}